export default {
  title: 'Components/Home Banner',
  component: 'dda-home-banner',
  argTypes: {
    autoplay: {
      control: 'boolean',
      description: 'Enable or disable autoplay functionality.',
      defaultValue: true,
    },
    interval: {
      control: 'number',
      description: 'Set the autoplay interval time in milliseconds.',
      defaultValue: 3000,
    },
  },
  parameters: {
    docs: {
      description: {
        component: `
The \`dda-home-banner\` component displays a carousel banner with optional autoplay functionality.

### Usage

\`\`\`html
<dda-home-banner
  autoplay="true"
  interval="3000"
>
  <div class="dda-home-banner-slide">Slide 1</div>
  <div class="dda-home-banner-slide">Slide 2</div>
  <div class="dda-home-banner-slide">Slide 3</div>
</dda-home-banner>
\`\`\`

### Props

- \`autoplay\` (boolean): Enables or disables automatic slide transitions.
- \`interval\` (number): Duration in milliseconds between slide transitions when autoplay is enabled.
        `,
      },
    },
    controls: {
      expanded: true,
    },
  },
};

const Template = (args) =>
  `<dda-home-banner autoplay='${args.autoplay}' interval='${args.interval}'>
    <div class="dda-home-banner-slide">Slide 1</div>
    <div class="dda-home-banner-slide">Slide 2</div>
    <div class="dda-home-banner-slide">Slide 3</div>
  </dda-home-banner>`;

export const Default = Template.bind({});
Default.args = {
  autoplay: true,
  interval: 3000,
};
